import { render, staticRenderFns } from "./people_appointment_import.vue?vue&type=template&id=2cf28823"
import script from "./people_appointment_import.vue?vue&type=script&lang=js"
export * from "./people_appointment_import.vue?vue&type=script&lang=js"
import style0 from "./people_appointment_import.vue?vue&type=style&index=0&id=2cf28823&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports